export default __webpack_public_path__ + "static/media/app_wizard_screenshot.7f522de7.png";